/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frhoorZk3bxNXU73uUyvHm
// Component: _uEitkIFZr

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import MenuButton from "../../components/widgets/MenuButton"; // plasmic-import: h69wHrrKtL/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frhoorZk3bxNXU73uUyvHm/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_state_management.css"; // plasmic-import: frhoorZk3bxNXU73uUyvHm/projectcss
import sty from "./PlasmicActionChip.module.css"; // plasmic-import: _uEitkIFZr/css

import BoltSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__BoltSvg"; // plasmic-import: IRA31HnIa/icon

createPlasmicElementProxy;

export type PlasmicActionChip__VariantMembers = {};
export type PlasmicActionChip__VariantsArgs = {};
type VariantPropType = keyof PlasmicActionChip__VariantsArgs;
export const PlasmicActionChip__VariantProps = new Array<VariantPropType>();

export type PlasmicActionChip__ArgsType = { actionName?: React.ReactNode };
type ArgPropType = keyof PlasmicActionChip__ArgsType;
export const PlasmicActionChip__ArgProps = new Array<ArgPropType>("actionName");

export type PlasmicActionChip__OverridesType = {
  root?: Flex__<"div">;
  text?: Flex__<"div">;
  svg?: Flex__<"svg">;
  menuButton?: Flex__<typeof MenuButton>;
};

export interface DefaultActionChipProps {
  actionName?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicActionChip__RenderFunc(props: {
  variants: PlasmicActionChip__VariantsArgs;
  args: PlasmicActionChip__ArgsType;
  overrides: PlasmicActionChip__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_frhoorZk3bxNXU73uUyvHm",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <div className={classNames("all", sty.freeBox__zcpRw)}>
        <div className={classNames("all", sty.freeBox__fJmat)}>
          <div className={classNames("all", sty.freeBox___4W5Bn)}>
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames("all", "__wab_text", sty.text)}
            >
              {"-"}
            </div>
          </div>
          <BoltSvgIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames("all", sty.svg)}
            role={"img"}
          />
        </div>
        <div className={classNames("all", sty.freeBox__lWbe1)}>
          {renderPlasmicSlot({
            defaultContents: "Action Name",
            value: args.actionName,
          })}
        </div>
      </div>
      <div className={classNames("all", sty.freeBox__yakOm)}>
        <MenuButton
          data-plasmic-name={"menuButton"}
          data-plasmic-override={overrides.menuButton}
          className={classNames("__wab_instance", sty.menuButton)}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "text", "svg", "menuButton"],
  text: ["text"],
  svg: ["svg"],
  menuButton: ["menuButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  text: "div";
  svg: "svg";
  menuButton: typeof MenuButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicActionChip__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicActionChip__VariantsArgs;
    args?: PlasmicActionChip__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicActionChip__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicActionChip__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicActionChip__ArgProps,
          internalVariantPropNames: PlasmicActionChip__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicActionChip__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicActionChip";
  } else {
    func.displayName = `PlasmicActionChip.${nodeName}`;
  }
  return func;
}

export const PlasmicActionChip = Object.assign(
  // Top-level PlasmicActionChip renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    svg: makeNodeComponent("svg"),
    menuButton: makeNodeComponent("menuButton"),

    // Metadata about props expected for PlasmicActionChip
    internalVariantProps: PlasmicActionChip__VariantProps,
    internalArgProps: PlasmicActionChip__ArgProps,
  }
);

export default PlasmicActionChip;
/* prettier-ignore-end */
